const state = {
  localStore: false,
  prefetched: false,
  swapTokens: [],
  localContracts: {}
};

export default state;
